export default __webpack_public_path__ + "ecaa799156efbd3209b58fc3d987131f.png";